<template>
  <div class="rhg-price-filter">
    <div v-show="!isMobile" class="rhg-price-filter-block">
      <label class="rhg-price-from-to-label">{{ translate('desFrom') }}</label>
      <span>{{ minPrice }} {{ currency }}</span>
    </div>
    <div class="rhg-slider-prices">
      <div ref="sliderPrices"></div>
    </div>
    <div v-show="!isMobile" class="rhg-price-filter-block">
      <label class="rhg-price-from-to-label">{{ translate('desTo') }}</label>
      <span>+{{ maxPrice }} {{ currency }}</span>
    </div>
    <div v-show="isMobile" class="w-100">
      <div class="d-flex justify-content-between">
        <div class="rhg-price-filter-block">
          <label class="rhg-price-from-to-label">{{ translate('desFrom') }}</label>
          <span>{{ minPrice }} {{ currency }}</span>
        </div>
        <div class="rhg-price-filter-block">
          <label class="rhg-price-from-to-label">{{ translate('desTo') }}</label>
          <span>+{{ maxPrice }} {{ currency }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider'

export default {
  name: 'PriceFilter',
  emits: ['updatePriceFilter', 'toggleClearPrice', 'priceFilterSelected'],
  props: {
    id: {
      type: String,
      requied: true
    },
    isMobile: {
      type: Boolean,
      requied: true
    },
    minRange: {
      type: Number,
      required: true
    },
    maxRange: {
      type: Number,
      required: true
    },
    clearPrice: {
      type: Boolean,
      requied: true,
      default: false
    }
  },
  data: () => ({
    minPrice: null,
    maxPrice: null,
    slider: null,
    currency: ''
  }),
  watch: {
    clearPrice(newValue) {
      if (newValue) {
        this.slider.noUiSlider.reset()
        this.$emit('toggleClearPrice')
      }
    }
  },
  mounted() {
    this.currency = window.Cookie.read(window.cookieDictionary.preferredCurrency)
    this.$nextTick(() => {
      this.slider = this.$refs.sliderPrices

      this.minPrice = this.minRange
      this.maxPrice = this.maxRange

      noUiSlider.create(this.$refs.sliderPrices, {
        start: [this.minPrice, this.maxPrice],
        connect: true,
        range: {
          min: this.minRange,
          max: this.maxRange
        }
      })

      const handleElements = this.slider.querySelectorAll('.noUi-handle')
      handleElements.forEach(handle => {
        handle.classList.add('custom-handle')
      })

      const connectBar = this.slider.querySelector('.noUi-connect')
      connectBar.classList.add('custom-connect')

      this.slider.noUiSlider.on('update', (values) => {
        this.minPrice = parseInt(values[0])
        this.maxPrice = parseInt(values[1])
        this.$emit('updatePriceFilter', { minPrice: parseFloat(values[0]), maxPrice: parseFloat(values[1]) })
      })

      this.slider.noUiSlider.on('end', (values) => {
        this.minPrice = parseInt(values[0])
        this.maxPrice = parseInt(values[1])
        this.$emit('priceFilterSelected', this.minPrice !== this.minRange || this.maxPrice !== this.maxRange)
      })
    })
  }
}
</script>

<style lang="scss">
.rhg-price-filter {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 991px) {
    flex-direction: row;
  }

  .rhg-price-filter-block {
    width: 140px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    padding: 6px 16px;
    display: flex;
    flex-direction: column;

    .rhg-price-from-to-label {
      font-size: 14px;
      line-height: 20px;
      color: #242424;
      opacity: 0.5;
    }

    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      color: #242424;
    }
  }

  .rhg-slider-prices {
    width: 100%;
    margin: auto;
    margin-bottom: 20px;

    @media(min-width: 991px) {
      margin-bottom: auto;
      width: 600px;
    }
  }
}

.custom-handle {
  width: 20px !important;
  height: 20px !important;
  background-color: #29343D !important;
  border: none !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  z-index: 1 !important;
}

.custom-connect {
  background-color: #29343D !important;
  height: 4px !important;
  z-index: 0 !important;
}

.noUi-target {
  box-shadow: none !important;
  border: 0 !important;
  background-color: #D8D8D8 !important;
  height: 4px !important;
  width: 95% !important;

  @media(min-width: 991px) {
    width: 580px !important;
  }
}

.noUi-handle {
  width: 20px !important;
  height: 20px !important;
  box-shadow: none !important;

  &:before {
    content: none !important;
  }

  &:after {
    content: none !important;
  }

}
</style>
